import React, { useState } from "react";
import { AssetHeader } from "./Assets.styled";
import DashboardLayout from "../Layout/DashboardLayout";
import { Tabs } from "antd";
import RawMaterials from "../admin/components/config/Inventory/RawMaterials/RawMaterials";
import Produces from "../admin/components/config/Inventory/Produces/Produces";

const { TabPane } = Tabs;
const InventoryManagement = () => {
  const [activeKey, setActiveKey] = useState("1");

  function callback() {
    setActiveKey(activeKey);
  }
  return (
    <DashboardLayout pageTitle="Sales">
      <AssetHeader data-aos="fade-right">
        <h3>Inventory Management</h3>
      </AssetHeader>
      <Tabs onChange={callback} defaultActiveKey="1">
        <TabPane tab="Raw Material Inventory" key="1">
          <RawMaterials />
        </TabPane>
        <TabPane tab="Product Inventory" key="2">
          <Produces />
        </TabPane>
      </Tabs>
    </DashboardLayout>
  );
};

export default InventoryManagement;
